module.exports = __webpack_public_path__ + "static/media/D.6d3ff3c4.png";